import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class PaymentSuccess {
    constructor(containerId, sessionId) {
        this.containerId = containerId;
        this.sessionId = sessionId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        this.injectStyles();

        const main = `
            <div class="fg-payment-result success">
                <div class="fg-payment-result__card">
                    <div class="fg-payment-result__badge">GOAL!</div>
                    <div class="fg-payment-result__icon">🏆</div>
                    <h1 class="fg-payment-result__title">THANK YOU!</h1>
                    <p class="fg-payment-result__text">Your order is confirmed and on its way to the pitch!</p>
                    
                    ${this.sessionId ? `
                        <div class="fg-payment-result__ref">
                            <span>Order Reference</span>
                            <strong>${this.sessionId.substring(0, 14)}...</strong>
                        </div>
                    ` : ''}

                    <div class="fg-payment-result__actions">
                        <button class="fg-btn fg-btn--primary" id="btn-success-shop">Continue Shopping</button>
                        <button class="fg-btn" id="btn-success-orders" style="border-color: #ddd; margin-top: 12px;">View Order History</button>
                    </div>
                </div>
            </div>
        `;

        el.innerHTML = sidebarPage({ title: '', main, wide: false, pageClass: 'fg-success-page' });
        this.attachEvents(el);
    }

    injectStyles() {
        const styleId = 'fg-payment-result-styles';
        if (document.getElementById(styleId)) return;
        const css = `
            .fg-payment-result { display: flex; align-items: center; justify-content: center; min-height: 60vh; padding: 20px; text-align: center; }
            .fg-payment-result__card { background: #fff; border-radius: 24px; padding: 48px 32px; box-shadow: 0 20px 40px rgba(0,0,0,0.1); max-width: 440px; width: 100%; border: 1px solid var(--border-color); position: relative; overflow: hidden; }
            .fg-payment-result__badge { position: absolute; top: 20px; left: -30px; background: var(--fitness-vibrant-pink); color: #fff; padding: 8px 40px; transform: rotate(-45deg); font-weight: 900; font-size: 0.8rem; letter-spacing: 1px; }
            .fg-payment-result__icon { font-size: 4rem; margin-bottom: 24px; filter: drop-shadow(0 10px 15px rgba(0,0,0,0.1)); }
            .fg-payment-result__title { font-size: 2.5rem; font-weight: 900; color: var(--text-primary); margin-bottom: 12px; letter-spacing: -1px; }
            .fg-payment-result__text { font-size: 1.1rem; color: var(--text-secondary); line-height: 1.5; margin-bottom: 32px; }
            .fg-payment-result__ref { background: var(--bg-secondary); padding: 16px; border-radius: 12px; margin-bottom: 32px; display: flex; flex-direction: column; gap: 4px; }
            .fg-payment-result__ref span { font-size: 0.75rem; text-transform: uppercase; font-weight: 700; color: #8a8d91; }
            .fg-payment-result__ref strong { font-family: monospace; font-size: 0.95rem; color: var(--primary-blue); }
            .fg-payment-result__actions .fg-btn { width: 100%; padding: 16px; border-radius: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; }
            
            [data-theme="dark"] .fg-payment-result__card { background: #242526; }
            [data-theme="dark"] .fg-payment-result__title { color: #fff; }
            [data-theme="dark"] .fg-payment-result__ref { background: #3a3b3c; }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    attachEvents(el) {
        el.querySelector('#btn-success-shop')?.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'shop' } }));
        });
        el.querySelector('#btn-success-orders')?.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'profile' } }));
        });
    }
}